export default "__VITE_ASSET__DhhbuhQY__"